import { render } from "./EditInfo.vue?vue&type=template&id=f328738c&scoped=true"
import script from "./EditInfo.vue?vue&type=script&lang=js"
export * from "./EditInfo.vue?vue&type=script&lang=js"

import "./EditInfo.vue?vue&type=style&index=0&id=f328738c&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f328738c"]])

export default __exports__